import { DeviceId } from '../models/Device';
import { DeviceProperty } from '../models/DeviceDetail';
import { UiProfileProperty, UiProfileSection } from '../models/UiProfile';

function extractPrecisionFromScaleFactor(scaleFactor: string) {
    if (scaleFactor.startsWith('0.')) {
        return scaleFactor.split('.')[1].length;
    }

    if (/^1\/10*$/.test(scaleFactor)) {
        return scaleFactor.split('/')[1].length - 1;
    }

    return 0;
}

export function enrichUiProperty(
    uiProperty: UiProfileProperty,
    metadata: DeviceProperty['metadata'],
): UiProfileProperty;
export function enrichUiProperty(
    uiProperty: UiProfileProperty | undefined,
    metadata: DeviceProperty['metadata'],
): UiProfileProperty | undefined;
export function enrichUiProperty(
    uiProperty: UiProfileProperty | undefined,
    metadata: DeviceProperty['metadata'],
): UiProfileProperty | undefined {
    if (!uiProperty) {
        return undefined;
    }

    if (metadata?.scaleFactor && uiProperty.formatter?.type === 'number') {
        return {
            ...uiProperty,
            formatter: {
                ...uiProperty.formatter,
                scaleFactor: metadata.scaleFactor,
                unit: metadata.unit,
                precision: extractPrecisionFromScaleFactor(metadata.scaleFactor),
            },
        };
    }

    if (metadata?.possibleValues) {
        return {
            ...uiProperty,
            editor: {
                type: 'namedValue',
                possibleValues: metadata.possibleValues,
            },
            formatter: {
                type: 'named-value',
                translationKey: uiProperty.label,
            },
        } as UiProfileProperty;
    }

    return uiProperty;
}

export function computeZigbeeSectionProperties(
    deviceId: DeviceId,
    propertiesKeys: string[],
    section: UiProfileSection,
): string[] {
    return section.properties
        .filter((propertyId) => propertiesKeys.includes(`${deviceId}.${propertyId}`))
        .filter(
            (propertyId) =>
                propertyId !== 'core:ProductSoftwareBuildIdState' ||
                !propertiesKeys.includes(`${deviceId}.Identification.MotorSoftRelease`),
        );
}
